var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause4 = function SvgIconPause4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38h13V0H0zm19 0h13V0H19z",
    fill: "#2B328C"
  })));
};
export default SvgIconPause4;